import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import "./App.scss";
import AlertModal from "./components/Alert";
import CardList from "./components/Card/CardList";
import EventSessions from "./components/EventSessions";
import MainNav from "./components/MainNav";
import Detail from "./components/Page/Detail";
import Partners from "./components/Partners";
import Profile from "./components/Profile";
import SessionDetail from "./components/SessionDetail";
import SpeakerDetail from "./components/SpeakerDetail";
import SponsorDetail from "./components/SponsorDetail";
import Video from "./components/Video";
import { UserProvider } from "./context/UserContext";
import { socket, SocketContext } from "./utils/socket";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <SocketContext.Provider value={socket}>
          <MainNav />
          <AlertModal />
          <UserProvider>
            <App />
            <Video />
            <Partners />
            <CardList />
          </UserProvider>
        </SocketContext.Provider>
      </>
    ),
  },
  {
    path: "/event/:eventId",
    element: (
      <>
        <SocketContext.Provider value={socket}>
          <MainNav />
          <AlertModal />
          <UserProvider>
            <EventSessions />
          </UserProvider>
        </SocketContext.Provider>
      </>
    ),
  },
  {
    path: "/session/:sessionId",
    element: (
      <>
        <SocketContext.Provider value={socket}>
          <MainNav />
          <AlertModal />
          <UserProvider>
            <SessionDetail />
          </UserProvider>
        </SocketContext.Provider>
      </>
    ),
  },
  {
    path: "/speaker/:speakerId",
    element: (
      <>
        <SocketContext.Provider value={socket}>
          <MainNav />
          <AlertModal />
          <UserProvider>
            <SpeakerDetail />
          </UserProvider>
        </SocketContext.Provider>
      </>
    ),
  },
  {
    path: "/sponsor/:sponsorId",
    element: (
      <>
        <SocketContext.Provider value={socket}>
          <MainNav />
          <AlertModal />
          <UserProvider>
            <SponsorDetail />
          </UserProvider>
        </SocketContext.Provider>
      </>
    ),
  },
  {
    path: "/profile",
    element: (
      <>
        <SocketContext.Provider value={socket}>
          <MainNav />
          <AlertModal />
          <UserProvider>
            <Profile />
          </UserProvider>
        </SocketContext.Provider>
      </>
    ),
  },
  {
    path: "/session/:id",
    element: (
      <>
        <SocketContext.Provider value={socket}>
          <MainNav />
          <AlertModal />
          <UserProvider>
            <Detail />
            <Partners />
            <CardList />
          </UserProvider>
        </SocketContext.Provider>
      </>
    ),
  }
]);

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Cannot find root element");
}
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <div className="grid grid-cols-1 lg:grid-cols-12 bg-white border-gray-300 border-1 border-b">
      <a href="/" className="lg:col-start-2 lg:col-span-10 flex justify-center">
        <img src="https://ecommerce-day-test.myshopify.com/cdn/shop/files/ecommercay_logo.png?height=80&v=1678723101" />
      </a>
    </div>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
